import {
    Box,
    Button,
    Typography
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import BasePageLayout from '../layout/BasePageLayout';
import { Trans } from 'react-i18next';

function InstituteNotEnabledPage() {

    return (
        <>
            <Box sx={{display : 'flex', justifyContent : 'center'}}>
                <BasePageLayout title={<Trans i18nKey={'entschuldigung'} ns='instituteNotEnabledPage'>Entschuldigung,</Trans>}>
                    <Box sx={{ width: 'fit-content', height: '600px' }}>
                        <Typography variant='h6'>
                            <Trans i18nKey={'nichtFreigeschaltet'} ns='instituteNotEnabledPage'>Dein Institut ist nicht für die Verwendung der Anwendung Freigegeben</Trans>
                        </Typography>
                    </Box>
                </BasePageLayout>
            </Box>
        </>
    );
}

export default InstituteNotEnabledPage
